import _alert from './alert';
import _partial from 'lodash/partial';
import { __ } from '@insolus/i18n';

var alert = function alert(type, text, title) {
  _alert({
    type: type,
    title: title,
    text: text
  });
};

var confirm = function confirm(text, title) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (title && typeof title === 'object') {
    options = title;
    title = undefined;
  }

  var params = {
    title: title || options.title || __('common:please-confirm'),
    confirmButtonText: options.button || __('common:confirm'),
    cancelButtonText: options.cancel || __('common:cancel'),
    danger: options.danger || false,
    type: 'warning',
    showCancelButton: true,
    text: text
  };
  return _alert(params).then(function (_ref) {
    var value = _ref.value;
    return !!value;
  });
};

export default {
  confirm: confirm,
  show: alert,
  success: _partial(alert, 'success'),
  info: _partial(alert, 'info'),
  warning: _partial(alert, 'warning'),
  error: function error(msg, title) {
    title = title || __('common:error-occured');
    msg = msg || __('common:error-occured-retry');
    alert('error', msg, title);
  }
};